import { useEffect, useRef, useState } from "react";
import axios from "axios";
import queryString from 'query-string';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { ServerAddress, Header, DomesticHotelApiUrls } from "../../Enum/Urls";
import { showError } from "../../Actions/VisualDataAction";
import { setSafarmarketHotelPixel } from "../../Actions/HotelAction";
import Loading from "../Common/Loading";
import LayoutConfig from "../../Config/layoutConfig";
import ImageGallery from "../Common/ImageGallery";
import Rating from "../Common/Rating";
import DomesticHotelDetailRooms from "./DomesticHotelDetailRooms";
import DomesticHotelDetailAbout from "./DomesticHotelDetailAbout";
import DomesticHotelSearchForm from "./DomesticHotelSearchForm";
import DomesticHotelDetailComments from "./DomesticHotelDetailComments";
import Map from "../Common/Map";
import DomesticHotelRoomSkeleton from "./DomesticHotelRoomSkeleton";
import SimilarHotels from "./SimilarHotels";
import FetchProgress from "../Common/FetchProgress";
import HotelDetailSkeleton from "../Common/HotelDetailSkeleton";
import { getDomesticHotelDetailsById } from "../../Actions/DomesticHotelAction";
import AccommodationFacilities from "./AccommodationFacilities";
import AccomodationPolicy from "./AccomodationPolicy";

const DomesticHotelDetail = props => {

    const parameters = queryString.parse(props.location.search);
    const { Dictionary } = props;
    const roomsHolder = useRef();

    const [hotelAllData, setHotelAllData] = useState();

    const [roomsInformation, setRoomsInformation] = useState();
    
    const [loading, setLoading] = useState(true);

    const [selectedRoomToken, setSelectedRoomToken] = useState();

    const accommodationData = hotelAllData?.accommodation?.result;
    const reviewData = hotelAllData?.reviews;
    const sheetData = hotelAllData?.sheet;

    const checkin = parameters.checkin || moment().format("YYYY-MM-DD");
    const checkout = parameters.checkout || moment().add(1, 'days').format("YYYY-MM-DD");

    const validateRoom = async (params) => {
        
        setSelectedRoomToken(params.bookingToken);

        const response = await axios.post(`${ServerAddress.Type}${ServerAddress.DomesticHotelB}${DomesticHotelApiUrls.Validate}`,
            params,
            {
                headers: {
                    ...Header,
                    apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
                    'Accept-Language': 'fa-IR'
                }
            }
        );
        if (response?.data?.result) {
            props.history.push(
                `/domesticHotel/getPassengers?preReserveKey=${response.data.result.preReserveKey}`
            );
        }
    }

    const selectRoomHandle = (token, count) => {
        
        const params = {
            bookingToken: token,
            checkin: checkin,
            checkout: checkout,
            count: count
        }
        validateRoom(params);

    }

    useEffect(() => {

        let smId;
        let cookies = decodeURIComponent(document.cookie).split(';');
        for (const item of cookies) {
            if (item.includes("safarMarketHotelId=")) {
                smId = item.split("=")[1];
            }
        }
        if (LayoutConfig.safarmarket && props.currency === "IRR" && smId) {
            props.setSafarmarketPixelValue(encodeURI(`https://safarmarket.com/api/hotel/v1/pixel/itours/2/0/?smId=${smId}`));
        }

        const fetchRoomsData = async () => {
            const hotelId = parameters.id;
            setRoomsInformation();
            axios.get(`${ServerAddress.Type}${ServerAddress.DomesticHotelB}${DomesticHotelApiUrls.GetRooms}?CheckIn=${checkin}&CheckOut=${checkout}&Id=${hotelId}`,
                {
                    headers: {
                        ...Header,
                        apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
                        'Accept-Language': 'fa-IR'
                    }
                }
            ).then(response => {
                if (response?.data) {
                    setRoomsInformation(response.data.result);
                }
            }).catch(error => {
                setRoomsInformation("error");
                console.dir(error?.response?.data?.error);
            });
        }

        const fetchHotelInformation = async () => {
            setLoading(true);
            setHotelAllData();
            const hotelId = parameters.id;
            const res = await getDomesticHotelDetailsById(hotelId);

            if (res?.data?.result) {
                setLoading(false);
                setHotelAllData(res.data.result);
            }
        }

        try {
            fetchRoomsData();
            fetchHotelInformation();
        } catch (err) {
            //check why this doesn't work
        }

    }, [props.location.search]);

    let modifiedImages;
    if (accommodationData?.galleries?.length) {
        modifiedImages = accommodationData.galleries.filter(item => item.filePath).map(item => {
            const mobileImage = item.sizes?.find(i => i.displaySize === "mobile")?.filePath;
            const desktopImage = item.sizes?.find(i => i.displaySize === "desktop")?.filePath;
            return ({
                large: desktopImage || item.filePath,
                thumbnail: mobileImage || item.filePath
            })
        })
    }

    // let rating;
    // if (scoreInformation) {
    //     rating = <DomesticHotelPoint point={scoreInformation.Satisfaction} reviews={scoreInformation.CommentCount} className="margin-bottom" />;
    // }

    const isStyle3 = LayoutConfig.themeClassName === 'style-3';

    const importantFacilities = accommodationData?.facilities?.flatMap(item => item.items)?.filter(item => item.isImportant);

    return (
        <div className="hotel-details">
            {!!isStyle3 && <FetchProgress compeleted={!loading} />}
            <div className="page-container no-padding-mobile">
                {loading ?
                    <>
                        {isStyle3 ? (
                            <HotelDetailSkeleton />
                        ) : (
                            <Loading fullPage description={Dictionary.getHotelInformation + " ..."} />
                        )}
                    </>
                    : accommodationData ? (
                        <div className="section-vertical-padding hotel-details domestic-hotel-details">
                            {/* {this.state.isFromSafarmarket && <h5 className="bg-white box-border margin-bottom-large card-padding normal-title safarmarket-welcome">
                                شما از موتور جستجو <b className="purple">سفرمارکت</b> به <b className="purple">آیتورز</b> هدایت شده اید. لطفا فرایند رزرو هتل خود را در این صفحه ادامه دهید.
                            </h5>} */}
                            <div className="hotel-head-info">
                                <div className="full-width">
                                    <h3 className="hotel-title">{accommodationData.displayName} </h3>
                                    {accommodationData.address && (
                                        <div className="hotel-address">
                                            <span className="itours-icon location-dark margin-end-light icon-small" />
                                            {accommodationData.address}
                                        </div>
                                    )}
                                    <div className="hotelRange">
                                        <Rating number={accommodationData.rating} className="inline-block-middle margin-end-half" />
                                    </div>
                                </div>
                                <div className="text-right">
                                    {/* {rating} */}
                                </div>

                            </div>

                            <div className={`box-border bg-white margin-bottom detail-section ${isStyle3 ? "" : "blue-border-right"}`}>
                                <div className="float-row no-gap ltr">
                                    <div
                                        className={`col-small-12 ${importantFacilities?.length > 0 && LayoutConfig.themeClassName !== "padide-com-theme" ? "col-large-9" : ""}`}
                                        dir="ltr"
                                    >
                                        {!!modifiedImages?.length ? (
                                            <ImageGallery images={modifiedImages} />
                                        ) : accommodationData.picture?.path ? (
                                            <img
                                                src={accommodationData.picture.path}
                                                alt={accommodationData.picture.altAttribute || accommodationData.displayName}
                                                className="full-width hotel-main-1photo"
                                            />
                                        ) : (
                                            <div className="card hotel-no-picture box-border text-center body-direction">
                                                <div className="no-image-hint ">
                                                    <div className="margin-bottom">
                                                        {Dictionary.noImageHeadingText}
                                                    </div>
                                                    <small>{Dictionary.noImageDetailText}</small>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {importantFacilities?.length > 0 ? (
                                        <div
                                            className={`col-small-12 ${LayoutConfig.themeClassName === "padide-com-theme" ? "" : "col-large-3"}`}
                                        >
                                            <div className="card-padding">
                                                <h5 className="normal-title">
                                                    {Dictionary.specialFacilities}
                                                </h5>

                                                <div className="feature-list">
                                                    <div className="feature-items">
                                                        {importantFacilities.map(facilityItem => <div
                                                            className={facilityItem.IsSpecial ? "is-important" : ""}
                                                            key={facilityItem.name}
                                                        >
                                                            {facilityItem.name}
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mobile-hr-padding">

                                <div className="margin-bottom-large">
                                    <h5 className="normal-title">{Dictionary.modifySearch}</h5>
                                    <DomesticHotelSearchForm noTabs selectedHotelName={accommodationData.displayName} />
                                </div>

                                <div className="room-select-card" id="roomSelectSection" ref={roomsHolder} >
                                    <h5 className="normal-title select-room-title">{Dictionary.selectRoom} </h5>
                                    <div id="roomSelect" className={"select-room-wrapper"}>
                                        {!roomsInformation ? (
                                            <DomesticHotelRoomSkeleton />
                                        )
                                            : (roomsInformation === "error" || roomsInformation?.availabilities?.length === 0) ? <div className="box-border margin-bottom card-padding bg-white text-center">
                                                <div className="margin-bottom">
                                                    <span className="itours-icon error-icon icon-xlarge" />
                                                </div>
                                                <div className="text-center font-18">
                                                    <div className="margin-bottom">
                                                        <strong>{Dictionary.SorryNoRoomFoundRightNow}!</strong>
                                                    </div>
                                                    <p>{Dictionary.pleaseTryAnotherHotel}</p>
                                                </div>
                                            </div>
                                                : roomsInformation?.availabilities?.map((availabilityItem, index) => <DomesticHotelDetailRooms
                                                    key={index}
                                                    selectedRoomToken={selectedRoomToken}
                                                    selectRoomHandle={selectRoomHandle}
                                                    availabilityItem={availabilityItem}
                                                    duration={roomsInformation?.date?.duration}
                                                />)}
                                    </div>
                                </div>

                                {!!accommodationData?.facilities && <AccommodationFacilities facilities={accommodationData.facilities} />}

                                <DomesticHotelDetailAbout loading={loading} data={accommodationData.description} />

                                <AccomodationPolicy policies={accommodationData.policies} mendatoryFee={accommodationData.mendatoryFee} loading={loading} />

                                <DomesticHotelDetailComments reviewData={reviewData} pageId={sheetData?.id} />

                                {!!accommodationData?.coordinates?.latitude && accommodationData?.coordinates?.longitude && <div className="box-border map-holder">
                                    <Map
                                        zoom={14}
                                        hotels={[{ latitude: accommodationData.coordinates.latitude, longitude: accommodationData.coordinates.longitude }]}
                                    />
                                </div>}

                                <SimilarHotels hotels={accommodationData?.similars} checkin={checkin} checkout={checkout} />
                            </div>

                        </div>
                    ) : null}
            </div>

        </div>
    )
}

const mapStateToProps = (state) => ({
    error: state.VisualData.error,
    currency: state.UserData.Currency,
    Dictionary: state.VisualData.Dictionary,
    selectedFilters: state.DomesticHotel.selectedFilters
});
const mapDispatchToProps = (dispatch) => ({
    showError: (param) => { dispatch(showError(param)); },
    setSafarmarketPixelValue: (data) => dispatch(setSafarmarketHotelPixel(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DomesticHotelDetail));